import React from 'react';
import { createRoot } from 'react-dom/client';
import DocumentsListing from './App';

const elementContainer = document.querySelector<HTMLElement>('#documents-listing-root');

if (elementContainer) {
  const root = createRoot(elementContainer);
  root.render(<DocumentsListing />);
}
